// Menu structure for sidebar - NEW STRUCTURE
export const menuStructure = [
  {
    id: "ce-si-cum-raportezi",
    title: "I. Ce și cum raportezi?",
    subsections: [
      { id: "ce-trebuie-sa-stii", title: "I.1 Ce trebuie să știi înainte de a depune o petiție?" },
      { id: "ce-tip-incidente", title: "I.2 Ce tip de incidente poți raporta?" },
      { id: "cadrul-legal", title: "I.3 Cadrul legal" },
    ],
  },
  {
    id: "discurs-infractiuni",
    title: "II. Discursul incitator la ură și infracțiunile motivate de ură",
    subsections: [
      { id: "ce-este-incident", title: "II.1 Ce este un incident motivat de ură?" },
      { id: "cand-devine-infractiune", title: "II.2 Când devine un incident motivat de ură o infracțiune?" },
      { id: "ce-este-discurs", title: "II.3 Ce este discursul incitator la ură?" },
    ],
  },
  {
    id: "antisemitism",
    title: "III. Ce este antisemitismul?",
    subsections: [],
  },
  {
    id: "rasism-antirom",
    title: "IV. Ce este rasismul antirom?",
    subsections: [],
  },
  {
    id: "discriminare",
    title: "V. Ce este discriminarea?",
    subsections: [
      { id: "forme-discriminare", title: "V.1 Ce forme de discriminare sunt recunoscute de legislația din România?" },
    ],
  },
  {
    id: "xenofobie",
    title: "VI. Ce este xenofobia?",
    subsections: [],
  },
  {
    id: "resurse",
    title: "VII. Resurse",
    subsections: [
      { id: "resurse-strategii", title: "VII.1 Strategii naționale" },
      { id: "resurse-ihra", title: "VII.2 Definiții și recomandări IHRA" },
      { id: "resurse-rapoarte", title: "VII.3 Rapoarte și studii INSHR-EW" },
      { id: "resurse-documente", title: "VII.4 Documente internaționale" },
      { id: "resurse-ehri-eric", title: "VII.5 Infrastructura Europeană de Cercetare a Holocaustului EHRI-ERIC" },
      { id: "resurse-premii-granturi", title: "VII.6 Premii, granturi și finanțări nerambursabile" },
    ],
  },
];

// Tooltip definitions for info markers
export const tooltipDefinitions = {
  "cncd": {
    title: "Consiliul Național pentru Combaterea Discriminării (CNCD)",
    content: "Autoritatea de stat autonomă, sub control parlamentar, care își desfășoară activitatea în domeniul discriminării. Este garant al respectării și aplicării principiului nediscriminării. Monitorizează, mediază, investighează și sancționează faptele de discriminare. Soluțiile sale pot fi contestate la instanțele de judecată.",
    link: { text: "Citește mai mult despre CNCD", href: "https://www.cncd.ro/" }
  },
  "avocatul-poporului": {
    title: "Instituția Avocatul Poporului",
    content: "Autoritatea publică autonomă şi independentă faţă de orice altă autoritate publică, care are drept scop apărarea drepturilor şi libertăţilor persoanelor fizice în raporturile acestora cu autoritățile publice. Adjuncții Avocatului Poporului sunt specializaţi pe domenii de activitate: drepturile omului, egalitate de şanse între bărbaţi şi femei, culte religioase și minorităţi naţionale; drepturile familiei, tinerilor, pensionarilor, persoanelor cu dizabilități; apărarea, protecția și promovarea drepturilor copilului; armată, justiţie, poliţie, penitenciare; proprietate, muncă, protecţie socială, impozite şi taxe; prevenirea torturii și a altor pedepse ori tratamente crude, inumane sau degradante în locurile de detenție.",
    link: { text: "Citește mai mult despre Avocatul Poporului", href: "https://avp.ro" }
  },
  "politist": {
    title: "Polițist",
    content: "Persoana căreia îi veți raporta faptul că ați fost victima/martorul unei infracțiuni motivate de ură. Vă va ajuta să formulați plângerea/denunțul și vă va cere să dați o declarație. Declarația cuprinde versiunea dumneavoastră despre modul în care s-au comis faptele vătămătoare. Dacă sunteți audiat ca martor, vi se va cere să depuneți un jurământ înainte de a da declarație. Polițistul va strânge probe cu privire la incidentul pe care l-ați sesizat. Polițistul îl va audia și pe cel bănuit de comiterea faptei. La finalul investigației, polițistul trimite dosarul unui procuror. Poate îndruma victimele către serviciile de sprijin sau organizațiile neguvernamentale.",
    link: { text: "Citește mai mult despre Poliția Română", href: "https://politiaromana.ro/ro/informatii-generale/scurt-istoric" }
  },
  "procuror": {
    title: "Procuror",
    content: "Persoana care verifică munca desfășurată de polițist și decide dacă va trimite cazul unui judecător (va formula o acuzație). Procurorul poate da sfaturi polițistului cu privire la modul de strângere a probelor. Poate decide, pe baza probelor, să închidă cazul sau că nu există interes în continuarea cercetărilor, în temeiul unor criterii cuprinse de lege. Soluțiile procurorului trebuie motivate și vi se vor aduce la cunoștință. Procurorul susține acuzația formulată în fața unui judecător prin prezentarea probelor de vinovăție și explicând modul de comitere a faptelor. Poate cere unei instanțe superioare rejudecarea cazului.",
    link: { text: "Citește mai mult despre Ministerul Public", href: "https://www.mpublic.ro/ro/content/prezentare-generala" }
  },
  "judecator": {
    title: "Judecător",
    content: "Ascultă părțile (inculpatul – cel împotriva căruia procurorul a formulat o acuzație; persoana vătămată – cel care a suferit un prejudiciu de orice fel prin infracțiune; partea civilă – persoana vătămată care a cerut să fie despăgubită), martorii (persoane care descriu ce au văzut, auzit sau dețin alte informații despre faptele cazului) și pe procuror și decide dacă în cauză poate stabili vinovăția celui acuzat de procuror și sancțiunea aplicabilă. Judecătorul poate ajunge și la concluzia că cel acuzat nu este vinovat și va dispune achitarea (absolvirea de acuzație). În formularea unui verdict, judecătorul se poate folosi și de alte probe (înscrisuri, expertize etc.). Hotărârile judecătorești se redactează în scris, se motivează și se comunică părților.",
    link: { text: "Citește mai mult despre instanțe", href: "https://portal.just.ro/SitePages/acasa.aspx" }
  },
  "rasa": {
    title: "Rasă",
    content: "Teoriile rasiale au fost invalidate științific. Oamenii aparțin aceleiași specii, nu există «rase» diferite. Însă prejudecățile rasiale (rasismul antirom) sunt încă răspândite și se află la baza multor incidente motivate de ură. Din acest motiv, criteriul «rasei» este păstrat în legislație, pentru a proteja persoanele vizate de ura provenită din atribuirea unei anumite «rase»."
  },
  "simboluri-fasciste": {
    title: "Simboluri fasciste, legionare, rasiste sau xenofobe",
    content: "Drapelele, emblemele, insignele, uniformele, sloganurile, formulele de salut, precum și orice alte asemenea însemne, care promovează ideile, concepțiile sau doctrinele fasciste, legionare, rasiste antirome, antisemite sau xenofobe."
  },
  "materiale-fasciste": {
    title: "Materiale fasciste, legionare, rasiste sau xenofobe",
    content: "Imagini, mesaje text, conținut audio-video, cărți, articole, alte documente și materiale de propagandă, precum și alte asemenea reprezentări, care transmit idei, concepții sau doctrine fasciste, legionare, rasiste antirome, antisemite, ori xenofobe."
  },
  "penal": {
    title: "Sancțiune penală (infracțiuni)",
    content: "Când a) fapta este prevăzută de legea penală (ex. Incitarea la violență, ură sau discriminare, omorul, lovirea sau alte violențe, distrugerea, violul) și b) autorul ei a acționat din prejudecată față de etnia, naționalitatea, religia, orientarea sexuală, genul, dizabilitatea sau alte criterii protejate, atribuite direct sau indirect subiectului vizat."
  },
  "contraventional": {
    title: "Sancțiune contravențională",
    content: "Art. 15 din O.G. nr. 137/2000 definește contravenția ca fiind fapta care nu intră sub incidența legii penale și constituie orice comportament manifestat în public, având caracter de propagandă naționalist-șovină, de instigare la ură rasială sau națională, ori acel comportament care are ca scop sau vizează atingerea demnității ori crearea unei atmosfere de intimidare, ostile, degradante, umilitoare sau ofensatoare, îndreptat împotriva unei persoane, unui grup de persoane sau unei comunități și legat de apartenența acestora la o anumită rasă, naționalitate, etnie, religie, categorie socială sau la o categorie defavorizată ori de convingerile, sexul sau orientarea sexuală a acestuia."
  },
  "organizatii-antisemite": {
    title: "Organizații cu caracter antisemit",
    content: "Orice grup format din trei sau mai multe persoane, care își desfășoară activitatea temporar sau permanent, în scopul promovării ideilor, concepțiilor sau doctrinelor antisemite. În această categorie pot fi incluse organizațiile cu sau fără personalitate juridică, partidele și mișcările politice, asociațiile și fundațiile, societățile reglementate de Legea societăților nr. 31/1990, republicată, cu modificările și completările ulterioare, precum și orice alte persoane juridice care intră sub incidența Legii nr. 157/2018."
  },
  "simboluri-antisemite": {
    title: "Simboluri antisemite",
    content: "Drapelele, emblemele, insignele, uniformele, sloganurile, formulele de salut, precum și orice alte asemenea însemne, care transmit idei, concepții sau doctrine care promovează antisemitismul."
  },
  "materiale-antisemite": {
    title: "Materiale antisemite",
    content: "Imagini, mesaje text, conținut audiovideo, precum și orice alte asemenea reprezentări, care transmit idei, concepții sau doctrine care promovează antisemitismul."
  },
  "organizatii-antirome": {
    title: "Organizații cu caracter antirom",
    content: "Orice grup format din trei sau mai multe persoane, care își desfășoară activitatea temporar sau permanent, în scopul promovării ideilor, concepțiilor sau doctrinelor antirome. În această categorie pot fi incluse organizațiile cu sau fără personalitate juridică, partidele și mișcările politice, asociațiile și fundațiile, societățile reglementate de Legea societăților nr. 31/1990, republicată, cu modificările și completările ulterioare, precum și orice alte persoane juridice care intră sub incidența Legii nr. 2/2021."
  },
  "simboluri-antirome": {
    title: "Simboluri antirome",
    content: "Drapelele, emblemele, insignele, uniformele, sloganurile, formulele de salut, precum și orice alte asemenea însemne, care transmit idei, concepții sau doctrine care promovează rasismul antirom."
  },
  "materiale-antirome": {
    title: "Materiale antirome",
    content: "Imagini, mesaje text, conținut audiovideo, precum și orice alte asemenea reprezentări, care transmit idei, concepții sau doctrine care promovează rasismul antirom."
  },
  "holocaust": {
    title: "Holocaustul",
    content: "Persecuția și exterminarea sistematică a aproximativ șase milioane de evrei de către regimul nazist și aliații săi în timpul celui de-al Doilea Război Mondial."
  },
  "cult-persoane": {
    title: "Cultul persoanelor vinovate de genocid",
    content: "Orice persoană condamnată definitiv de către o instanță judecătorească română ori străină sau prin orice hotărâre recunoscută în România, potrivit legii, pentru una sau mai multe infracțiuni de genocid, contra umanității și de război, precum și persoana din conducerea unei organizații al cărei caracter criminal a fost constatat prin hotărârea unei instanțe penale internaționale."
  },
  "cult-conducere": {
    title: "Organizații cu caracter fascist, legionar, rasist sau xenofob",
    content: "Prin organizație cu caracter fascist, legionar, rasist sau xenofob se înțelege orice grup format din trei sau mai multe persoane, care își desfășoară activitatea temporar sau permanent, în scopul promovării ideilor, concepțiilor sau doctrinelor fasciste, legionare, rasiste sau xenofobe, precum ura și violența pe motive etnice, rasiale sau religioase, superioritatea unor rase și inferioritatea altora, incitarea la xenofobie, recurgerea la violență pentru schimbarea ordinii constituționale sau a instituțiilor democratice, naționalismul extremist. În această categorie pot fi incluse organizațiile cu sau fără personalitate juridică, partidele și mișcările politice, asociațiile și fundațiile, societățile reglementate de Legea societăților nr. 31/1990, republicată, cu modificările și completările ulterioare. Prin organizații legionare se face referire la Mișcarea Legionară: O organizație fascistă din România care a activat în perioada 1927-1941 sub denumirile de «Legiunea Arhanghelul Mihail», «Garda de Fier» și «Partidul Totul pentru Țară»."
  },
  "negare-holocaust": {
    title: "Negarea Holocaustului",
    richContent: [
      { type: "paragraph", text: "Negarea Holocaustului este o formă specifică de antisemitism care se manifestă de regulă prin:" },
      { type: "list", items: [
        "eforturi intenționate de a scuza sau minimaliza impactul Holocaustului sau al elementelor sale principale, inclusiv colaboratori și aliați ai Germaniei naziste;",
        "minimalizarea masivă a numărului victimelor Holocaustului, în contradicție cu informațiile ce provin din surse credibile;",
        "încercări de a susține că evreii și-au cauzat propriul genocid;",
        "declarații ce prezintă Holocaustul ca fiind un eveniment istoric pozitiv;",
        "încercări de a dilua responsabilitatea pentru înființarea de lagăre de concentrare și exterminare, concepute și operate de către Germania nazistă, prin învinovățirea altor țări sau grupuri etnice. Holocaustul este persecuția sistematică sprijinită de stat și anihilarea evreilor europeni de către Germania nazistă, precum și de aliații și colaboratorii săi din perioada 1933-1945. De asemenea, în perioada celui de-al Doilea Război Mondial, o parte din populația romă a fost supusă deportării și anihilării. Holocaustul pe teritoriul României este înțeles ca persecuția sistematică și anihilarea evreilor și a romilor, sprijinită de autoritățile și instituțiile statului român în teritoriile administrate de acesta în perioada 1940-1944."
      ]}
    ]
  },
  "organizatii-grup": {
    title: "Organizații cu caracter fascist, legionar, rasist sau xenofob",
    content: "Prin organizație cu caracter fascist, legionar, rasist sau xenofob se înțelege orice grup format din trei sau mai multe persoane, care își desfășoară activitatea temporar sau permanent, în scopul promovării ideilor, concepțiilor sau doctrinelor fasciste, legionare, rasiste sau xenofobe, precum ura și violența pe motive etnice, rasiale sau religioase, superioritatea unor rase și inferioritatea altora, incitarea la xenofobie, recurgerea la violență pentru schimbarea ordinii constituționale sau a instituțiilor democratice, naționalismul extremist. În această categorie pot fi incluse organizațiile cu sau fără personalitate juridică, partidele și mișcările politice, asociațiile și fundațiile, societățile reglementate de Legea societăților nr. 31/1990, republicată, cu modificările și completările ulterioare. Prin organizații legionare se face referire la Mișcarea Legionară: O organizație fascistă din România care a activat în perioada 1927-1941 sub denumirile de «Legiunea Arhanghelul Mihail», «Garda de Fier» și «Partidul Totul pentru Țară»."
  },
  "discriminare-directa": {
    title: "Discriminare directă",
    richContent: [
      { type: "paragraph", text: "Discriminarea directă reprezintă situația în care o persoană este tratată mai puțin favorabil decât este, a fost sau ar fi tratată o altă persoană într-o situație comparabilă, pe baza unui criteriu protejat." },
      { type: "heading", text: "Caracteristici" },
      { type: "paragraph", text: "Discriminarea directă este de obicei evidentă și relativ ușor de dovedit, deoarece tratamentul diferențiat este clar legat de criteriul protejat. Nu există justificare pentru discriminarea directă, cu excepția situațiilor strict prevăzute de lege (de exemplu, cerințe ocupaționale autentice)." }
    ]
  },
  "discriminare-indirecta": {
    title: "Discriminare indirectă",
    richContent: [
      { type: "paragraph", text: "Discriminarea indirectă apare atunci când o dispoziție, un criteriu sau o practică aparent neutră ar dezavantaja în mod special anumite persoane pe baza criteriilor protejate (ex. etnie, religie, orientare sexuală etc.), în raport cu alte persoane, cu excepția cazului în care această dispoziție, acest criteriu sau această practică este justificat(ă) în mod obiectiv de un scop legitim, iar mijloacele de atingere a acelui scop sunt corespunzătoare și necesare." },
      { type: "heading", text: "Justificare" },
      { type: "paragraph", text: "Spre deosebire de discriminarea directă, discriminarea indirectă poate fi justificată dacă se demonstrează că:" },
      { type: "list", items: [
        "Există un scop legitim pentru măsura în cauză",
        "Mijloacele utilizate sunt corespunzătoare pentru atingerea acelui scop",
        "Mijloacele utilizate sunt necesare (nu există alternative mai puțin discriminatorii)"
      ]}
    ]
  },
  "discriminare-multipla": {
    title: "Discriminare multiplă (intersecțională)",
    richContent: [
      { type: "paragraph", text: "Discriminarea multiplă (sau intersecțională) apare atunci când o persoană este discriminată pe baza mai multor criterii protejate simultan. Această formă de discriminare recunoaște că identitățile și experiențele persoanelor sunt formate de intersecția mai multor caracteristici." },
      { type: "heading", text: "Importanță" },
      { type: "paragraph", text: "Recunoașterea discriminării multiple este importantă deoarece:" },
      { type: "list", items: [
        "Experiența discriminării poate fi calitativ diferită când sunt implicate criterii multiple",
        "Persoanele care aparțin mai multor grupuri dezavantajate pot fi și mai vulnerabile",
        "Măsurile anti-discriminare trebuie să țină cont de complexitatea identităților",
        "Sancțiunile și remediile pot fi mai severe în cazul discriminării pe criterii multiple."
      ]}
    ]
  },
  "hartuire": {
    title: "Hărțuire",
    richContent: [
      { type: "paragraph", text: "Hărțuirea reprezintă orice comportament nedorit care are ca scop sau efect atingerea demnității unei persoane și de a crea o atmosferă intimidantă, ostilă, degradantă, umilitoare sau ofensatoare, pe baza unui criteriu protejat." },
      { type: "heading", text: "Aspecte importante" },
      { type: "paragraph", text: "Este important de reținut că:" },
      { type: "list", items: [
        "Hărțuirea nu trebuie să fie intenționată pentru a fi ilegală - ceea ce contează este efectul asupra victimei",
        "Un singur incident poate constitui hărțuire dacă este suficient de grav",
        "Comportamentul poate fi considerat hărțuire chiar dacă victima nu a obiectat direct",
        "Angajatorii au responsabilitatea de a preveni și sancționa hărțuirea la locul de muncă"
      ]}
    ]
  },
  "victimizare": {
    title: "Victimizare",
    richContent: [
      { type: "paragraph", text: "Victimizarea reprezintă un tratament defavorabil aplicat unei persoane ca reacție la o plângere sau la o acțiune în justiție cu privire la respectarea principiului tratamentului egal și al nediscriminării. Cu alte cuvinte, este o formă de represalii împotriva celor care raportează sau se opun discriminării." },
      { type: "heading", text: "Protecție legală" },
      { type: "paragraph", text: "Legislația anti-discriminare protejează în mod special împotriva victimizării, recunoscând că:" },
      { type: "list", items: [
        "Persoanele trebuie să poată raporta discriminarea fără teama de represalii",
        "Martorii trebuie să poată depune mărturie fără a fi pedepsiți",
        "Avocații și alți susținători ai victimelor trebuie să fie protejați",
        "Victimizarea este o formă distinctă de discriminare care poate fi sancționată separat"
      ]},
      { type: "heading", text: "Forme de victimizare" },
      { type: "list", items: [
        "Concedierea sau refuzul de promovare a unei persoane care a depus o plângere pentru discriminare",
        "Hărțuirea sau intimidarea unei persoane care a fost martor într-un caz de discriminare",
        "Excluderea din activități sau oportunități a unei persoane care a raportat discriminare",
        "Deteriorarea reputației sau răspândirea de zvonuri despre o persoană care s-a plâns de discriminare",
        "Reducerea salariului sau a beneficiilor unei persoane care a inițiat o acțiune în justiție"
      ]}
    ]
  },
  "dispozitie": {
    title: "Dispoziția de a discrimina",
    richContent: [
      { type: "paragraph", text: "În contextul legislației anti-discriminare, dispoziția se referă la orice act normativ, regulament, clauză contractuală, dispoziție statuară sau orice alte acte care conțin prevederi discriminatorii sau care pot conduce la situații discriminatorii." },
      { type: "heading", text: "Tipuri de dispoziții problematice" },
      { type: "list", items: [
        "Regulamente interne ale companiilor care conțin cerințe discriminatorii",
        "Statute ale organizațiilor care exclud anumite categorii de persoane",
        "Clauze contractuale care tratează în mod diferit persoanele pe baza criteriilor protejate",
        "Politici publice sau private care au efect discriminatoriu",
        "Criterii de selecție care dezavantajează în mod nejustificat anumite grupuri"
      ]},
      { type: "heading", text: "Nulitate" },
      { type: "paragraph", text: "Conform legislației române, orice dispoziție contrară principiului tratamentului egal este considerată nulă de drept. Aceasta înseamnă că:" },
      { type: "list", items: [
        "Astfel de dispoziții nu au efecte juridice din momentul adoptării lor",
        "Nu este necesară o hotărâre judecătorească pentru a stabili nulitatea",
        "Persoanele afectate pot refuza să respecte astfel de dispoziții",
        "Autoritățile competente pot solicita modificarea sau eliminarea acestor dispoziții"
      ]}
    ]
  }
};

// Content data for each section
export const contentData = {
  "ce-si-cum-raportezi": {
    title: "I. Ce și cum raportezi?",
    sections: [
      {
        subsectionLinks: [
          { id: "ce-trebuie-sa-stii", title: "I.1 Ce trebuie să știi înainte de a depune o petiție?" },
          { id: "ce-tip-incidente", title: "I.2 Ce tip de incidente poți raporta?" },
          { id: "cadrul-legal", title: "I.3 Cadrul legal" }
        ]
      }
    ],
    subsections: {
      "ce-trebuie-sa-stii": {
        title: "I.1 Ce trebuie să știi înainte de a depune o petiție?",
        sections: [
          {
            list: [
              "Fiecare autoritate și instituție publică gestionează sesizările în funcție de prevederile legislației în vigoare aplicabile și de propriile reglementări.",
              "Nu este responsabilitatea ta să încadrezi juridic faptele. Descrie cât mai clar ce s-a întâmplat, iar profesioniștii din instituțiile competente vor analiza și vor decide ce instituții și încadrări juridice sunt potrivite.",
              "Ne ajută să cunoști datele de identificare ale celui/celei care a comis fapta, însă nu este obligatoriu.",
              "Este necesar să ai un minim de dovezi, nu este suficient doar să depui o petiție.",
              "Dacă sesizezi aceeași problemă prin mai multe petiții, acestea vor fi conexate și vei primi un singur răspuns.",
              "Nu ai nevoie de avocat/ă pentru a depune o sesizare, însă dacă decizi pentru, cheltuielile de judecată nu sunt de competența autorităților/instituțiilor sesizate.",
              "Autoritățile și instituțiile publice sesizate au obligația de a răspunde în termen de 30 de zile de la data înregistrării petiției, indiferent dacă soluția este favorabilă sau nefavorabilă. Termenul poate fi prelungit cu cel mult 15 zile, dacă este necesară o cercetare mai amănunțită.",
              "Răspunsul îți va fi transmis de către instituțiile/autoritățile competente, precum și prin intermediul acestei platforme.",
              "Datele tale sunt protejate.",
              "Restabilirea situației anterioare sau înlăturarea consecințelor faptei de discriminare nu intră în competența autorităților/instituțiilor sesizate."
            ]
          },
          {
            heading: "Cine are atribuții pe linia incidentelor motivate de ură?",
            tooltipList: [
              { text: "Consiliul Național pentru Combaterea Discriminării (CNCD)", tooltipId: "cncd" },
              { text: "Instituția Avocatul Poporului", tooltipId: "avocatul-poporului" },
              { text: "Polițist", tooltipId: "politist" },
              { text: "Procuror", tooltipId: "procuror" },
              { text: "Judecător", tooltipId: "judecator" }
            ]
          }
        ]
      },
      "ce-tip-incidente": {
        title: "I.2 Ce tip de incidente poți raporta?",
        sections: [
          {
            content: "Prin această platformă poți raporta:"
          },
          {
            richTooltipList: [
              [{ text: "Amenințarea unei persoane sau a unui grup de persoane (inclusiv online) pe bază de antisemitism, rasism și xenofobie." }],
              [{ text: "Incitarea publicului la violență, ură și discriminare împotriva unei persoane sau unui grup de persoane ales pe bază de antisemitism, rasism și xenofobie." }],
              [{ text: "Lovire sau alte violențe pe bază de antisemitism, rasism și xenofobie." }],
              [{ text: "Distrugere pe bază de antisemitism, rasism și xenofobie." }],
              [
                { text: "Discriminare pe bază de " },
                { text: "rasă", tooltipId: "rasa" },
                { text: ", etnie, naționalitate, religie." }
              ],
              [
                { text: "Confecționarea, vânzarea, răspândirea, precum și deținerea în vederea răspândirii de " },
                { text: "simboluri antisemite, antirome, fasciste, legionare, rasiste sau xenofobe", tooltipId: "simboluri-fasciste" },
                { text: "." }
              ],
              [
                { text: "Distribuirea ori utilizarea în public a " },
                { text: "materialelor antisemite, antirome, fasciste, legionare, rasiste sau xenofobe", tooltipId: "materiale-fasciste" },
                { text: "." }
              ],
              [{ text: "Promovarea, în public, a ideilor, concepțiilor sau doctrinelor antisemite, antirome, fasciste, legionare, rasiste sau xenofobe." }],
              [
                { text: "Promovarea, în public, a " },
                { text: "cultului persoanelor vinovate de săvârșirea unor infracțiuni de genocid, contra umanității și de război", tooltipId: "cult-persoane" },
                { text: "." }
              ],
              [
                { text: "Promovarea, în public, a " },
                { text: "cultului persoanelor care au făcut parte din conducerea organizațiilor fasciste, legionare, rasiste sau xenofobe", tooltipId: "cult-conducere" },
                { text: "." }
              ],
              [
                { text: "Negarea, contestarea, aprobarea, justificarea sau minimalizarea în mod evident, în public, a Holocaustului și, respectiv, a Holocaustului pe teritoriul României", tooltipId: "negare-holocaust" },
                { text: "." }
              ],
              [
                { text: "Inițierea sau constituirea unei organizații cu caracter antisemit, antirom, fascist, legionar, rasist ori xenofob, aderarea la sau sprijinirea unui astfel de grup", tooltipId: "organizatii-grup" },
                { text: "." }
              ]
            ]
          }
        ]
      },
      "cadrul-legal": {
        title: "I.3 Cadrul legal",
        sections: [
          {
            richList: [
              [
                { text: "Codul penal", href: "https://legislatie.just.ro/Public/DetaliiDocument/223635", color: "#1565C0" },
                { text: " (art. 369 Incitarea la violență, ură sau discriminare)." }
              ],
              [
                { text: "Ordonanța nr. 137/2000", href: "https://legislatie.just.ro/Public/DetaliiDocument/256298", color: "#1565C0" },
                { text: " privind prevenirea și sancționarea tuturor formelor de discriminare." }
              ],
              [
                { text: "O.U.G. nr. 31/2002", href: "https://legislatie.just.ro/Public/DetaliiDocument/34759", color: "#1565C0" },
                { text: " privind interzicerea organizațiilor, simbolurilor și faptelor cu caracter fascist, legionar, rasist sau xenofob și a promovării cultului persoanelor vinovate de săvârșirea unor infracțiuni de genocid, contra umanității și de război (art. 3 - 6¹)." }
              ],
              [
                { text: "Legea nr. 157/2018", href: "https://legislatie.just.ro/Public/DetaliiDocument/202199", color: "#1565C0" },
                { text: " privind unele măsuri pentru prevenirea și combaterea antisemitismului (art. 3 - 6)." }
              ],
              [
                { text: "Legea nr. 2/2021", href: "https://legislatie.just.ro/Public/DetaliiDocument/235923", color: "#1565C0" },
                { text: " privind unele măsuri pentru prevenirea și combaterea rasismului antirom (art. 3 - 6)." }
              ]
            ]
          }
        ]
      }
    }
  },

  "discurs-infractiuni": {
    title: "II. Discursul incitator la ură și infracțiunile motivate de ură",
    sections: [
      {
        subsectionLinks: [
          { id: "ce-este-incident", title: "II.1 Ce este un incident motivat de ură?" },
          { id: "cand-devine-infractiune", title: "II.2 Când devine un incident motivat de ură o infracțiune?" },
          { id: "ce-este-discurs", title: "II.3 Ce este discursul incitator la ură?" }
        ]
      }
    ],
    subsections: {
      "ce-este-incident": {
        title: "II.1 Ce este un incident motivat de ură?",
        sections: [
          {
            richContent: [
              { text: "Un " },
              { text: "incident motivat de ură", bold: true },
              { text: " este o manifestare (fizică sau discursivă) care are la bază prejudecăți față de o persoană sau un grup de persoane privind:" }
            ]
          },
          {
            richTooltipList: [
              [{ text: "Etnia" }],
              [{ text: "Naționalitatea" }],
              [{ text: "Rasa", tooltipId: "rasa" }, { text: ", culoarea pielii" }],
              [{ text: "Religia" }],
              [{ text: "Orientarea sexuală" }],
              [{ text: "Sexul / Genul" }],
              [{ text: "Limba vorbită" }],
              [{ text: "Vârsta" }],
              [{ text: "Dizabilitatea" }],
              [{ text: "Apartenența la o anumită categorie socială sau la o categorie defavorizată" }],
              [{ text: "Convingerile sau apartenența politică" }],
              [{ text: "Averea" }],
              [{ text: "Infectarea cu HIV/SIDA" }],
              [{ text: "Boli cronice necontagioase" }],
              [{ text: "Alte împrejurări de același fel, considerate de făptuitor drept cauze ale inferiorității unei persoane în raport cu celelalte (pentru infracțiuni)" }],
              [{ text: "Orice alt criteriu care are ca scop sau ca efect restrângerea ori împiedicarea exercitării, în condiții de egalitate, a drepturilor și libertăților fundamentale sau a altor drepturi recunoscute de lege, în domeniul politic, economic, social, cultural sau în orice alt domeniu al vieții publice (pentru contravenții)" }]
            ]
          }
        ]
      },
      "cand-devine-infractiune": {
        title: "II.2 Când devine un incident motivat de ură o infracțiune?",
        sections: [
          {
            richContent: [
              { text: "Vorbim de " },
              { text: "infracțiune motivată de ură", bold: true, underline: true },
              { text: " atunci când există o faptă prevăzută de legea penală (ex. omorul, lovirea, distrugerea, violul) iar autorul ei a acționat din " },
              { text: "prejudecată", italic: true },
              { text: "." }
            ]
          },
          {
            warning: "Atenție: Nu orice comportament motivat de ură are la bază o prejudecată. Spre exemplu, un conflict între doi vecini care conduce la violență sau distrugerea proprietății constituie o infracțiune, însă nu este una motivată de prejudecată decât în cazul în care motivul ei ține de etnie, religie sau alte criterii protejate."
          },
          {
            warning: "Atenție: nu orice incident motivat de ură este automat infracțiune și nu orice astfel de faptă duce la o condamnare penală. Decizia privind încadrarea faptei și tipul de răspundere juridică aparține organelor judiciare (procuror, instanță de judecată), respectiv celor administrative cu activitate jurisdicțională (CNCD)."
          },
          {
            richContent: [
              { text: "Prin urmare, " },
              { text: "incidentele motivate de ură", bold: true },
              { text: " pot fi sancționate:" }
            ]
          },
          {
            tooltipList: [
              { text: "Penal (ca infracțiuni)", tooltipId: "penal" },
              { text: "Contravențional (ca fapte mai puțin grave, sancționate cu amendă)", tooltipId: "contraventional" }
            ]
          },
          {
            content: "Pentru a diferenția între cele două, se ține cont de criterii precum conținutul mesajului și intenția, rolul și statutul făptașului/vorbitorului, impactul potențial (mărimea și tipul publicului căruia i se adresează, contextul politic și social)."
          },
          {
            heading: "Cum denunți o infracțiune (penal)?",
            richContent: [
              { text: "Dacă ai fost subiectul unei " },
              { text: "infracțiuni motivate de ură", bold: true },
              { text: ", poți face " },
              { text: "plângere penală", bold: true },
              { text: ". Dacă nu ești tu persoana vătămată, poți face un " },
              { text: "denunț", bold: true },
              { text: ". De asemenea, organul judiciar se poate sesiza și din oficiu, folosind diverse surse de informație." }
            ]
          },
          {
            richContent: [
              { text: "Plângerea și denunțul trebuie să cuprindă anumite elemente obligatorii care sunt descrise în " },
              { text: "art. 289", italic: true },
              { text: " și " },
              { text: "art. 290", italic: true },
              { text: " din " },
              { text: "Codul de procedură penală", href: "https://legislatie.just.ro/Public/DetaliiDocument/185907", color: "#1565C0" },
              { text: ". În absența lor, plângerea sau denunțul se pot întoarce către persoana care le-a întocmit, fără a produce rezultate." }
            ]
          }
        ]
      },
      "ce-este-discurs": {
        title: "II.3 Ce este discursul incitator la ură?",
        sections: [
          {
            content: "Discursul incitator la ură este una din formele cele mai brutale de încălcare a limitelor libertății de exprimare. El se manifestă prin mesaje care incită, promovează, răspândesc sau justifică violența, ura sau discriminarea împotriva unei persoane sau a unui grup de persoane sau care le denigrează, din cauza unor prejudecăți legate de caracteristicile sau statutul lor personal real sau atribuit."
          },
          {
            warning: "Atenție: există și «discriminare prin asociere». Spre exemplu, partenerul neevreu al unui evreu sau prietenul heterosexual al unei persoane LGBT pot fi victime ale infracțiunilor motivate de ură, pe baza asocierii lor cu grupurile față de care sunt manifestate prejudecățile."
          },
          {
            heading: "Libertatea de exprimare",
            content: "Libertatea de exprimare este esențială într-o societate democratică. Ea protejează nu doar opiniile cu care majoritatea este de acord, ci și ideile care pot deranja, șoca sau ofensa. În același timp, democrația se bazează și pe respect, toleranță și protejarea demnității fiecărei persoane. Discriminarea, incitarea la ură și la violență încalcă aceste drepturi și norme democratice, depășind limitele libertății de exprimare protejate prin lege. Restricționarea libertății de exprimare trebuie să fie justificată și proporțională cu scopul urmărit."
          },
          {
            content: "Atunci când analizează dacă libertatea de exprimare a fost depășită, Curtea Europeană a Drepturilor Omului (CEDO) ține cont de mai mulți factori, care se aplică și în mediul online:"
          },
          {
            list: [
              "dacă declarațiile au fost rostite într-un climat social sau politic tensionat",
              "dacă declarațiile pot fi interpretate ca o chemare directă sau indirectă la violență, ură sau discriminare",
              "modul în care declarațiile au fost făcute și dacă pot produce consecințe vătămătoare, direct sau indirect",
              "intenția vorbitorului/făptașului",
              "potențialul mesajului / faptei de a incita la violență"
            ]
          }
        ]
      }
    }
  },

  "antisemitism": {
    title: "III. Ce este antisemitismul?",
    sections: [
          {
            richContent: [
              { text: "Antisemitismul este o formă specifică de prejudecată care stă la baza infracțiunilor motivate de ură sau discursului " },
              { text: "incitator", underline: false },
              { text: " la ură îndreptate împotriva populației evreiești." }
            ]
          },
          {
            content: "Antisemitismul reprezintă percepția referitoare la evrei exprimată ca ură împotriva acestora, cât și manifestările verbale sau fizice motivate de ură împotriva evreilor, îndreptate împotriva evreilor (sau, prin asociere, a ne-evreilor) ori a proprietăților acestora, împotriva instituțiilor comunităților evreiești sau lăcașurilor lor de cult."
          },
          {
            richContent: [
              { text: "Legea 157/2018 privind unele măsuri pentru prevenirea și combaterea antisemitismului", href: "https://legislatie.just.ro/Public/DetaliiDocument/202199", color: "#1565C0", underline: true },
              { text: " pedepsește constituirea " },
              { text: "organizațiilor cu caracter antisemit", underline: true, tooltipId: "organizatii-antisemite" },
              { text: ", precum și răspândirea de " },
              { text: "simboluri", underline: true, tooltipId: "simboluri-antisemite" },
              { text: " și " },
              { text: "materiale antisemite", underline: true, tooltipId: "materiale-antisemite" },
              { text: "." }
            ]
          },
          {
            richContent: [
              { text: "O formă specifică de antisemitism este " },
              { text: "negarea Holocaustului", bold: true, underline: true },
              { text: ", care se manifestă de regulă prin:" }
            ]
          },
          {
            list: [
              "eforturi intenționate de a scuza sau minimaliza impactul Holocaustului sau al elementelor sale principale, inclusiv colaboratori și aliați ai Germaniei naziste",
              "minimalizarea masivă a numărului victimelor Holocaustului, în contradicție cu informațiile ce provin din surse credibile",
              "încercări de a susține că evreii și-au cauzat propriul genocid",
              "declarații ce prezintă Holocaustul ca fiind un eveniment istoric pozitiv",
              "încercări de a dilua responsabilitatea pentru înființarea de lagăre de concentrare și exterminare, concepute și operate de către Germania nazistă, prin învinovățirea altor țări sau grupuri etnice"
            ]
          }
    ]
  },

  "rasism-antirom": {
    title: "IV. Ce este rasismul antirom?",
    sections: [
          {
            content: "Rasismul antirom este o formă specifică de prejudecată care stă la baza infracțiunilor motivate de ură sau discursului incitator la ură îndreptate împotriva populației rome."
          },
          {
            content: "Este percepția referitoare la romi exprimată ca ură împotriva acestora, cât și manifestările verbale sau fizice, motivate de ură împotriva romilor, îndreptate împotriva romilor ori a proprietăților acestora, împotriva instituțiilor/ONG-urilor, liderilor comunităților rome sau lăcașurilor lor de cult, tradițiilor și limbii romani."
          },
          {
            richContent: [
              { text: "Spre exemplu, legea nr. 2/2021 privind unele măsuri pentru prevenirea și combaterea rasismului antirom", href: "https://legislatie.just.ro/Public/DetaliiDocument/235923", color: "#1565C0", underline: true },
              { text: " pedepsește:" }
            ]
          },
          {
            tooltipList: [
              { text: "constituirea organizațiilor cu caracter antirom", tooltipId: "organizatii-antirome" },
              { text: "răspândirea de simboluri antirome", tooltipId: "simboluri-antirome" },
              { text: "răspândirea de materiale antirome", tooltipId: "materiale-antirome" }
            ]
          }
    ]
  },

  "discriminare": {
    title: "V. Ce este discriminarea?",
    sections: [
      {
        content: "Discriminarea reprezintă orice deosebire, excludere, restricție sau preferință care are ca scop sau efect restrângerea, înlăturarea recunoașterii, folosinței sau exercitării, în condiții de egalitate, a drepturilor omului și a libertăților fundamentale sau a drepturilor recunoscute de lege, în domeniul politic, economic, social și cultural sau în orice alte domenii ale vieții publice, pe baza:"
      },
      {
        richTooltipList: [
          [{ text: "Etniei" }],
          [{ text: "Naționalității" }],
          [{ text: "Rasei", tooltipId: "rasa" }],
          [{ text: "Limbii" }],
          [{ text: "Religiei" }],
          [{ text: "Categoriei sociale" }],
          [{ text: "Convingerilor" }],
          [{ text: "Sexului" }],
          [{ text: "Orientării sexuale" }],
          [{ text: "Vârstei" }],
          [{ text: "Dizabilității" }],
          [{ text: "Bolii cronice necontagioase" }],
          [{ text: "Infectării cu HIV/SIDA" }],
          [{ text: "Apartenenței la o categorie defavorizată" }],
          [{ text: "Oricărui alt criteriu invocat pentru restrângerea sau împiedicarea exercitării drepturilor și libertăților fundamentale sau recunoscute de lege." }]
        ]
      }
    ],
    subsections: {
      "forme-discriminare": {
        title: "V.1 Ce forme de discriminare sunt recunoscute de legislația din România?",
        sections: [
          {
            content: "Legislația română recunoaște mai multe forme de discriminare, fiecare cu caracteristici specifice: discriminarea directă, indirectă, multiplă (intersecțională), hărțuirea, victimizarea, dispoziția."
          },
          {
            heading: "Discriminare directă",
            tooltipId: "discriminare-directa",
            content: "Exemple:"
          },
          {
            list: [
              "Refuzul unui angajator de a angaja o persoană pe baza etniei sale",
              "Refuzul unei școli de a înscrie un copil din cauza religiei familiei",
              "Refuzul unui restaurant de a deservi clienți pe baze rasiale"
            ]
          },
          {
            heading: "Discriminare indirectă",
            tooltipId: "discriminare-indirecta",
            content: "Exemple:"
          },
          {
            list: [
              "Un program de lucru inflexibil care nu permite practicarea unor obligații religioase",
              "Cerințe lingvistice excesive care nu sunt necesare pentru îndeplinirea sarcinilor postului",
              "Teste sau criterii de evaluare care dezavantajează în mod disproporționat persoanele aparținând anumitor grupuri etnice sau religioase"
            ]
          },
          {
            heading: "Discriminare multiplă / intersecțională",
            tooltipId: "discriminare-multipla",
            content: "Exemple:"
          },
          {
            list: [
              "Femeie romă care este discriminată atât pe bază de gen cât și pe bază de etnie",
              "Femeie musulmană care poartă văl și este discriminată pe bază de religie și gen",
              "Bărbat gay de culoare care este victima prejudecăților rasiale și homofobe",
              "Persoană tânără de etnie romă cu dizabilități care se confruntă cu discriminarea pe baza vârstei, etniei și dizabilității"
            ]
          },
          {
            heading: "Hărțuire",
            tooltipId: "hartuire",
            content: "Exemple:"
          },
          {
            list: [
              "Hărțuire verbală: insulte, glume ofensatoare, remarci degradante",
              "Hărțuire fizică: gesturi obscene, violență fizică, contact fizic nedorit",
              "Hărțuire vizuală: afișarea de materiale ofensatoare, imagini sau simboluri",
              "Hărțuire online: mesaje amenințătoare, postări pe rețele sociale, cyberbullying (violență psihologică)",
              "Hărțuire prin excludere: izolarea sistematică a unei persoane din activități sau decizii"
            ]
          },
          {
            content: "La locul de muncă, hărțuirea poate include:"
          },
          {
            richTooltipList: [
              [{ text: "Comportament repetat și nedorit care creează un mediu de lucru ostil" }],
              [{ text: "Remarci sau glume pe bază de " }, { text: "rasă", tooltipId: "rasa" }, { text: ", sex, religie sau alte criterii protejate" }],
              [{ text: "Amenințări sau intimidări legate de performanța profesională" }],
              [{ text: "Excluderea sistematică din reuniuni sau activități profesionale" }],
              [{ text: "Sabotarea deliberată a muncii unei persoane" }]
            ]
          },
          {
            heading: "Victimizare",
            tooltipId: "victimizare",
            content: "Exemple:"
          },
          {
            list: [
              "Un angajat care a depus o plângere pentru discriminare rasială este apoi transferat într-un departament mai puțin dorit",
              "O persoană care a fost martoră într-un caz de hărțuire sexuală și apoi este izolată de colegi",
              "Un activist pentru drepturile omului care este amenințat sau atacat pentru activitatea sa",
              "O persoană care raportează discriminare și apoi este tratată diferit de managementul companiei"
            ]
          },
          {
            heading: "Dispoziția de discriminare",
            tooltipId: "dispozitie",
            content: "Exemple:"
          },
          {
            list: [
              "O clauză într-un regulament intern care interzice angajarea persoanelor care au o anumită religie",
              "O prevedere statutară care exclude persoanele aparținând unor minorități etnice din anumite funcții de conducere",
              "Un criteriu de admitere la școală care dezavantajează copiii dintr-o anumită etnie"
            ]
          }
        ]
      }
    }
  },

  "xenofobie": {
    title: "VI. Ce este xenofobia?",
    sections: [
      {
        content: "Xenofobia este o atitudine, un discurs sau un comportament ce respinge, exclude și adesea defăimează o persoană sau un grup, pe baza percepției că aceștia sunt intruși sau străini în comunitate, societate sau raportat la identitatea națională."
      },
      {
        content: "O infracțiune bazată pe xenofobie reprezintă o încălcare penală, motivată de discriminare, ostilitate sau prejudecată față de anumite persoane, din cauza originii, naționalității sau etniei lor reale sau percepute."
      }
    ]
  },

  "resurse": {
    title: "VII. Resurse",
    sections: [
      {
        content: "Această secțiune conține documente, definiții, strategii și rapoarte relevante pentru înțelegerea și combaterea antisemitismului, rasismului și discursului instigator la ură."
      },
      {
        subsectionLinks: [
          { id: "resurse-strategii", title: "VII.1 Strategii naționale" },
          { id: "resurse-ihra", title: "VII.2 Definiții și recomandări IHRA" },
          { id: "resurse-rapoarte", title: "VII.3 Rapoarte și studii INSHR-EW" },
          { id: "resurse-documente", title: "VII.4 Documente internaționale" },
          { id: "resurse-ehri-eric", title: "VII.5 Infrastructura Europeană de Cercetare a Holocaustului EHRI-ERIC" },
          { id: "resurse-premii-granturi", title: "VII.6 Premii, granturi și finanțări nerambursabile" }
        ]
      }
    ],
    subsections: {
      "resurse-ihra": {
        title: "VII.2 Definiții și recomandări IHRA",
        sections: [
          {
            content: "Alianța Internațională pentru Memoria Holocaustului (IHRA) elaborează definiții de lucru și recomandări pentru combaterea antisemitismului și discriminării."
          },
          {
            heading: "Definiții de lucru IHRA"
          },
          {
            resourceLinks: [
              { title: "Definiția de lucru a antisemitismului a IHRA", href: "https://holocaustremembrance.com/resources/definitia-de-lucru-a-antisemitismului", type: "external" },
              { title: "Definiţia de lucru a negării și distorsionării Holocaustului", href: "https://holocaustremembrance.com/resources/definition-holocaust-denial-distortion-17", type: "external" },
              { title: "Definiţia de lucru a anti-țigănismului / discriminării împotriva romilor a IHRA", href: "https://holocaustremembrance.com/resources/definitia-de-lucru-a-anti-tiganismului-discriminarii-impotriva-romilor", type: "external" },
              { title: "Definiția de lucru a IHRA referitoare la materiale legate de Holocaust", href: "https://holocaustremembrance.com/resources/definitia-de-lucru-a-ihra-referitoare-la-materiale-legate-holocaust", type: "external" },
              { title: "Carta Internațională a Muzeelor Memorial", href: "https://holocaustremembrance.com/resources/carta-internationala-a-muzeelor-memorial", type: "external" }
            ]
          },
          {
            heading: "Ghiduri și recomandări IHRA"
          },
          {
            resourceLinks: [
              { title: "The IHRA Working Definition of Antisemitism: A Guide to Implementation for Sporting Institutions", href: "https://holocaustremembrance.com/wp-content/uploads/2024/08/ihra-antisemitism-guide-sports.pdf", type: "external" },
              { title: "Recommendations for Dealing with Antisemitism at Universities with Teacher Education", href: "https://holocaustremembrance.com/resources/recommendations-combat-antisemitism-classroom", type: "external" }
            ]
          },
          {
            heading: "Documente IHRA"
          },
          {
            resourceLinks: [
              { title: "Carta pentru salvgardarea siturilor", href: "/resurse/ihra/Carta_pentru_salvgardarea_siturilor.pdf", type: "pdf" },
              { title: "FINAL IHRA Recommendations for Archaeologists", href: "/resurse/ihra/FINAL_IHRA-Recommendations-for-Archaeologists.pdf", type: "pdf" },
              { title: "Ghidul IHRA de identificare a documentației relevante pentru cercetarea Holocaustului, educație și memorie", href: "/resurse/ihra/Ghidul_IHRA_de_identificare_a_documentatiei_relevante_pentru_cercetarea_Holocaustului_educatie_si_memorie.pdf", type: "pdf" },
              { title: "IHRA – Reflecții privind terminologia pentru compararea Holocaustului", href: "/resurse/ihra/IHRA_Reflectii_privind_terminologia_pentru_compararea_Holocaustului.pdf", type: "pdf" },
              { title: "Recomandări privind predarea și învățarea despre Holocaust", href: "/resurse/ihra/Recomandari_privind_predarea_si_invatarea_despre_Holocaust.pdf", type: "pdf" },
              { title: "Recomandări privind accesul la arhive, monitorizarea accesului la colecții dedicate Holocaustului – Zagreb 2023", href: "/resurse/ihra/Recomandari_privind_accesul_la_arhive_monitorizarea_accesului_la_colectii_dedicate_Holocaustului_Zagreb_2023.docx", type: "docx" },
              { title: "Recomandările IHRA pentru predarea și învățarea despre persecuția și genocidul romilor", href: "/resurse/ihra/Recomandarile_IHRA_pentru_predarea_si_invatarea_despre_persecutia_si_genocidul_romilor.pdf", type: "pdf" },
              { title: "Recunoașterea și contracararea distorsionării Holocaustului - recomandări pentru responsabilii cu formularea politicilor și factorii de decizie", href: "/resurse/ihra/Recunoasterea_si_contracararea_distorsionarii_Holocaustului_-_recomandari_pentru_responsabilii_cu_formularea_politicilor_si_factorii_de_decizie.pdf", type: "pdf" },
              { title: "Handbook for the Practical Use of the IHRA Definition of Antisemitism", href: "/resurse/ihra/handbook-for-the-practical-use-of-the-IHRA-definition-ofantisemitism.pdf", type: "pdf" }
            ]
          }
        ]
      },
      "resurse-strategii": {
        title: "VII.1 Strategii naționale",
        sections: [
          {
            content: "Strategiile naționale pentru prevenirea și combaterea antisemitismului, xenofobiei, radicalizării și discursului instigator la ură."
          },
          {
            heading: "Strategia 2024-2027"
          },
          {
            resourceLinks: [
              { title: "Strategia națională pentru prevenirea și combaterea antisemitismului, xenofobiei, radicalizării și a discursului instigator la ură 2024-2027", href: "https://cancelarie.gov.ro/wp-content/uploads/2024/07/Monitorul-Oficial-Partea-I-nr.-503Bis.pdf", type: "external" },
              { title: "Raport Anual privind stadiul implementării Strategiei Naționale 2024-2027", href: "https://www.gov.ro/fisiere/stiri_fisiere/Raport_anual_Strategie_2024-2027.pdf", type: "external" }
            ]
          },
          {
            heading: "Strategia 2021-2023"
          },
          {
            resourceLinks: [
              { title: "Strategia națională pentru prevenirea și combaterea antisemitismului, xenofobiei, radicalizării și discursului instigator la ură 2021-2023", href: "https://monitoruloficial.ro/Monitorul-Oficial--PI--517--2021.html", type: "external" },
              { title: "Raportul final de implementare a Strategiei naționale 2021-2023", href: "https://www.gov.ro/fisiere/programe_fisiere/Raport_final_strategie_mai_2022.pdf", type: "external" },
              { title: "Raport de etapă cu privire la progresul înregistrat în implementarea strategiei 2021-2023", href: "https://gov.ro/fisiere/stiri_fisiere/Raport_implementare_Strategie_2021-2023.pdf", type: "external" },
              { title: "Raportul anual cu privire la progresul înregistrat în implementarea strategiei 2021-2023", href: "https://gov.ro/fisiere/comunicate_fisiere/Raport.pdf", type: "external" }
            ]
          },
          {
            heading: "Documente strategice (versiuni în limba engleză)"
          },
          {
            resourceLinks: [
              { title: "EU Strategy on Combating Antisemitism and Fostering Jewish Life (2021-2030)", href: "/resurse/strategii/EU_Strategy_on_combating_antisemitism_and_fostering_Jewish_life_(2021-2030).pdf", type: "pdf" },
              { title: "First Progress Report of the EU Strategy on Combating Antisemitism and Fostering Jewish Life", href: "/resurse/strategii/First_progress_report_of_the_EU_Strategy_on_combating_antisemitism_and_fostering_Jewish_Life.pdf", type: "pdf" },
              { title: "Implementation Report - 2021-2023 National Strategy", href: "/resurse/strategii/Implementation_report_-_2021-2023_National_Strategy.pdf", type: "pdf" },
              { title: "Plan de Acțiune 2024-2027 (EN)", href: "/resurse/strategii/Plan_de_Actiune_2024-2027_EN.pdf", type: "pdf" },
              { title: "Strategie 2024-2027 (EN)", href: "/resurse/strategii/Strategie_2024-2027-EN.pdf", type: "pdf" },
              { title: "The 2021-2023 National Strategy for Preventing and Combating Antisemitism, Xenophobia, Radicalisation and Hate Speech", href: "/resurse/strategii/The_2021-2023_National_Strategy_for_preventing_and_combating_antisemitism,_xenophobia,_radicalisation_and_hate_speech.pdf", type: "pdf" }
            ]
          }
        ]
      },
      "resurse-rapoarte": {
        title: "VII.3 Rapoarte și studii INSHR-EW",
        sections: [
          {
            content: "Rapoarte și studii elaborate de Institutul Național pentru Studierea Holocaustului din România «Elie Wiesel» (INSHR-EW)."
          },
          {
            heading: "Rapoarte de monitorizare"
          },
          {
            resourceLinks: [
              { title: "Raport antisemitism și negarea Holocaustului 2025", href: "/resurse/inshr-ew/Raport_antisemitism_si_negarea_Holocaustului_2025.pdf", type: "pdf" },
              { title: "Raport de monitorizare - antisemitismul în România înainte și după 7 octombrie 2023", href: "/resurse/inshr-ew/Raport_de_monitorizare_-_antisemitismul_in_Romania_inainte_si_dupa_7_octombrie_2023.pdf", type: "pdf" },
              { title: "Raport de monitorizare mai 2022-aprilie 2023", href: "/resurse/inshr-ew/Raport_de_monitorizare_mai_2022-aprilie_2023.pdf", type: "pdf" },
              { title: "Raport de monitorizare aprilie 2021-mai 2022", href: "/resurse/inshr-ew/Raport_de_monitorizare_aprilie_2021-mai_2022.pdf", type: "pdf" },
              { title: "Raport de monitorizare mai 2020-aprilie 2021", href: "/resurse/inshr-ew/Raport_de_monitorizare_mai_2020-aprilie_2021.pdf", type: "pdf" }
            ]
          },
          {
            heading: "Sondaje de opinie și studii"
          },
          {
            resourceLinks: [
              { title: "Sondaj de opinie – percepții privind minoritățile și Holocaustul noiembrie 2025", href: "/resurse/inshr-ew/Sondaj_de_opinie_perceptii_privind_minoritatile_si_Holocaustul_noiembrie_2025.pdf", type: "pdf" },
              { title: "Sondaj de opinie – percepții ale românilor asupra minorităților 2023", href: "/resurse/inshr-ew/Sondaj_de_opinie_perceptii_ale_romanilor_asupra_minoritatilor_2023.pdf", type: "pdf" },
              { title: "Raport de cercetare privind percepțiile minorității evreiești asupra societății românești 2023", href: "/resurse/inshr-ew/Raport_de_cercetare_privind_perceptiile_minoritatii_evreiesti_asupra_societatii_romanesti_2023.pdf", type: "pdf" },
              { title: "Opinii contradictorii și prejudecăți stabile despre evrei și Holocaustul din România - Sondaj de opinie 2021", href: "/resurse/inshr-ew/Opinii_contradictorii_si_prejudecati_stabile_despre_evrei_si_Holocaustul_din_Romania_Sondaj_de_opinie_2021.pdf", type: "pdf" }
            ]
          }
        ]
      },
      "resurse-documente": {
        title: "VII.4 Documente internaționale",
        sections: [
          {
            content: "Documente și ghiduri internaționale pentru combaterea antisemitismului."
          },
          {
            resourceLinks: [
              { title: "Global Guidelines on Countering Antisemitism", href: "/resurse/Global_Guidelines_on_countering_antisemitism.pdf", type: "pdf" },
              { title: "Declarația comună a Trimișilor Speciali și a Coordonatorilor pentru combaterea antisemitismului (12 mai 2026)", href: "https://commission.europa.eu/document/b460e9f7-09e4-41d5-ae3f-01e50052342c_en", type: "external" }
            ]
          }
        ]
      },
      "resurse-ehri-eric": {
        title: "VII.5 Infrastructura Europeană de Cercetare a Holocaustului EHRI-ERIC",
        sections: [
          {
            content: "Misiunea EHRI-ERIC constă în depășirea fragmentării geografice a resurselor documentare și a expertizei academice, stabilind standarde de excelență în cercetarea, documentarea, educația și comemorarea Holocaustului la nivel transnațional."
          },
          {
            content: "Lansat în 2010 și inclus din 2018 pe foaia de parcurs a Forumului European Strategic pentru Infrastructuri de Cercetare (ESFRI), proiectul a evoluat prin Decizia Comisiei Europene din 20 ian. 2025, devenind consorțiu pentru o infrastructură europeană de cercetare (ERIC). România participă în calitate de stat fondator al EHRI-ERIC."
          },
          {
            richContent: [
              { text: "Accesați platformele EHRI → " },
              { text: "https://www.ehri-project.eu/", href: "https://www.ehri-project.eu/", color: "#1565C0" },
              { text: " și " },
              { text: "https://www.ehri.ro/", href: "https://www.ehri.ro/", color: "#1565C0" }
            ]
          }
        ]
      },
      "resurse-premii-granturi": {
        title: "VII.6 Premii, granturi și finanțări nerambursabile",
        sections: [
          {
            heading: "Premiul Național „Ambasador Mihnea Constantinescu”",
            content: "În temeiul Legii nr. 67/2024, Ministerul Afacerilor Externe decernează anual acest premiu pentru a onora demersurile remarcabile în combaterea antisemitismului, xenofobiei, radicalizării și a discursului instigator la ură.",
            links: [{ text: "https://www.mae.ro/node/65571", href: "https://www.mae.ro/node/65571" }]
          },
          {
            heading: "Premiul European Simone Veil",
            content: "Acest premiu evidențiază rolul patrimoniului cultural și al locurilor de memorie în stimularea spiritului civic, a educației și a implicării democratice, reflectând totodată aportul fundamental al moștenirii culturale evreiești la istoria europeană comună.",
            links: [{ text: "https://culture.ec.europa.eu/it/cultural-heritage/initiatives-and-success-stories/simone-veil-prize", href: "https://culture.ec.europa.eu/it/cultural-heritage/initiatives-and-success-stories/simone-veil-prize" }]
          },
          {
            heading: "Administrația Fondului Cultural Național",
            content: "AFCN pune la dispoziție următoarele categorii de resurse:",
            list: [
              "finanțări nerambursabile, acordate prin concurs, pentru proiecte culturale desfășurate în plan intern sau internațional (organizate în două sesiuni anuale);",
              "finanțări specifice pentru susținerea proiectelor din sfera editorială (o sesiune anuală)."
            ],
            links: [{ text: "https://www.afcn-proiecte.ro/", href: "https://www.afcn-proiecte.ro/" }]
          },
          {
            heading: "Agenția Națională pentru Romi",
            richContent: [
              { text: "Agenția organizează anual sesiuni de finanțare nerambursabilă. Detalii privind tematicile și calendarul apelurilor pot fi consultate pe pagina instituției, la secțiunea " },
              { text: "http://www.anr.gov.ro/", href: "http://www.anr.gov.ro/", color: "#1565C0" },
              { text: " (Despre instituție → Programe și strategii → Finanțări)." }
            ]
          },
          {
            heading: "Institutul Cultural Român",
            content: "ICR acordă sprijin financiar prin Programul Cantemir, dedicat finanțărilor nerambursabile.",
            links: [{ text: "https://www.icr.ro/categorii/programul-cantemir", href: "https://www.icr.ro/categorii/programul-cantemir" }]
          },
          {
            heading: "Departamentul pentru Relații Interetnice",
            richContent: [
              { text: "DRI oferă finanțări nerambursabile pentru inițiative interetnice, promovarea identității culturale, lingvistice și religioase, protejarea drepturilor minorităților naționale și combaterea intoleranței. Informații suplimentare sunt disponibile la " },
              { text: "https://dri.gov.ro/ro/", href: "https://dri.gov.ro/ro/", color: "#1565C0" },
              { text: " (secțiunea Proiecte → Finanțări nerambursabile)." }
            ]
          },
          {
            heading: "Programul de granturi IHRA",
            content: "Alianța Internațională pentru Memoria Holocaustului (IHRA) finanțează anual, prin acest program, proiecte implementate de organizații partenere.",
            links: [{ text: "https://holocaustremembrance.com/what-we-do/what-we-fund#grant-program-guidelines", href: "https://holocaustremembrance.com/what-we-do/what-we-fund#grant-program-guidelines" }]
          }
        ]
      }
    }
  }
};
